<p>spotlight-event-stamp works!</p>
